import React from 'react';
import { IoWarning } from 'react-icons/io5';
import { MdOutlineTimer } from 'react-icons/md';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

function Account() {
    const { user } = useAppSelector(state => state.user);

    return (
        <div className='account'>
            <div className='account__column'>
                <div className='account__plan'>
                    <div className='account__planInfo'>
                        <h4 className='account__planInfoText'>
                            Current Plan: {user.bundle
                                ? <b className='account__planInfoPremium'>{user.bundle.name}</b>
                                : <b>Diagnostic Starter</b>
                            }
                        </h4>
                        <div className={user.bundle ? 'account__premium' : 'account__free'}>
                            <p>{user.bundle ? 'Premium' : 'Free'}</p>
                        </div>
                    </div>
                    
                    {user.bundle
                    ?   <p className='account__expiration'>
                            <MdOutlineTimer /> &nbsp;active until {new Date(user.bundle.expirationDate).toLocaleDateString()}
                        </p>
                    :   <div className='account__warning'>
                            <IoWarning className='account__warningIcon' />
                            <p className='account__warningText'>
                                Please ask your tutor about if/when to upgrade your account.
                            </p>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Account;